import { useNavigate } from 'react-router-dom';
import { LineChart, ShieldCheck } from 'lucide-react';
import SearchBar from './SearchBar';
import TopMoversInline from './TopMoversInline';
import MarketNewsWidget from './MarketNewsWidget';

import FundInsightsPreview from './super-investors/FundInsightsPreview';
import { EarningsInsightsPreview } from './earnings/EarningsInsightsPreview';

export function Hero() {
  const navigate = useNavigate();

  return (
    <section className="relative overflow-hidden bg-theme-primary text-theme-primary py-0 isolate antialiased pt-4">
      {/* Animated gradient backdrop (further desaturated) */}
      <div className="pointer-events-none absolute inset-0">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-900/8 via-theme-primary to-theme-primary" />
      </div>

      {/* Content */}
      <div className="relative z-10 mx-auto max-w-screen-2xl px-4 sm:px-6 lg:px-8">
        {/* Top-aligned wrapper (removed vertical centering) */}
        <div className="pt-0 pb-10">
          <div className="w-full grid grid-cols-1 lg:grid-cols-2 gap-5 xl:gap-8 items-start lg:items-center">
            {/* Left: Messaging */}
            <div className="lg:pr-8 min-w-0">
              <h1 className="headline-sm font-display mb-3 tracking-tight mt-2">
                Visual insights from{' '}
                <span className="bg-gradient-to-r from-blue-400 to-green-400 bg-clip-text text-transparent">
                  SEC filings, earnings, and fundamentals.
                </span>
              </h1>
              <p className="subtext-lg text-theme-secondary mb-4 max-w-xl">
                Don’t just read numbers. See the story, run your own scenarios, and invest smarter.
              </p>

              {/* Trust bar */}
              <div className="flex items-center gap-4 text-theme-muted text-[11px] md:text-xs">
                <div className="flex items-center gap-2">
                  <ShieldCheck className="h-4 w-4 text-emerald-400" />
                  Secure & privacy-first
                </div>
                <div className="hidden sm:flex items-center gap-2">
                  <LineChart className="h-4 w-4 text-blue-400" />
                  Real-time data search
                </div>
              </div>

              {/* Search */}
              <div className="mt-3">
                <SearchBar />
              </div>

              {/* Action Prompts */}
              <div className="mt-3">
                <p className="text-sm text-theme-muted mb-2">Try these feature demos</p>
                <div className="flex flex-wrap gap-2">
                  {/* ============================================
                      FEATURE REMOVED - Tesla Income Sankey
                      Date removed: January 23, 2026
                      Income Statement Sankey chart removed from UI
                      ============================================ */}
                  {/* <button
                    onClick={() => navigate('/TSLA/financials/income-statement')}
                    className="inline-flex items-center bg-blue-600/20 hover:bg-blue-600/30 text-blue-400 border border-blue-600/40 rounded-full px-3 py-1.5 text-sm transition-colors"
                  >
                    View Tesla's Income Sankey
                  </button> */}
                  <button
                    onClick={() => navigate('/compare?symbols=META,PLTR')}
                    className="inline-flex items-center bg-emerald-600/20 hover:bg-emerald-600/30 text-emerald-400 border border-emerald-600/40 rounded-full px-3 py-1.5 text-sm transition-colors"
                  >
                    Compare Meta vs. Palantir fundamentals
                  </button>
                  <button
                    onClick={() => navigate('/NVDA/forecast')}
                    className="inline-flex items-center bg-purple-600/20 hover:bg-purple-600/30 text-purple-400 border border-purple-600/40 rounded-full px-3 py-1.5 text-sm transition-colors"
                  >
                    Run your own bull/bear case on Nvidia
                  </button>
                </div>
              </div>
            </div>

            {/* Right: Inline Top Movers (now visible on mobile stacked below) */}
            <div className="pt-6 lg:pt-0">
              <TopMoversInline />
            </div>
          </div>
        </div>

        {/* Fund Insights Preview */}
        <div className="pb-10">
          <FundInsightsPreview />
        </div>

        {/* Earnings Insights Preview */}
        <div className="pb-10">
          <EarningsInsightsPreview />
        </div>

        {/* Feature highlights (below the fold) */}
        {/* Market News & IPO Widget */}
        <div className="pb-16">
          <MarketNewsWidget />
        </div>
      </div>
    </section>
  );
}